<template lang="pug">
  section.issue-list
    v-card-title
      v-btn(icon class="back-btn")
        v-icon(large color="primary" @click="$router.go(-1)") arrow_back
      h3 Задачи
      v-btn(icon class="info-btn" @click="openModal")
        v-icon(large color="primary") help_outline
    v-card-text
      v-layout(row justify-center class="px-4")
        v-flex(sm3 class="mx-2")
          span.upperLine Статус
          v-select(
            :items="statusList",
            v-model="selectStatus",
            item-value="status",
            item-text="title"
            flat,
            solo,
            placeholder="Выберете статус")
        v-flex(sm3 class="mx-2")
          span.upperLine Период с:
          v-menu(
            ref="menu"
            :close-on-content-click="false",
            v-model="menu1",
            min-width="290px",
            full-width)
            v-text-field(
              slot="activator",
              v-model="dateFrom",
              single-line,
              solo,
              flat,
              placeholder="Период c:")
            v-date-picker(
              no-title
              scrollable
              ref="picker"
              locale="ru"
              v-model="dateFrom"
              @input="menu1 = false")
        v-flex(sm3 class="mx-2")
          span.upperLine Период по:
          v-menu(
            ref="menu"
            :close-on-content-click="false",
            v-model="menu2",
            min-width="290px",
            full-width)
            v-text-field(
              slot="activator",
              v-model="dateTo",
              single-line,
              solo,
              flat,
              placeholder="Период по:")
            v-date-picker(
              no-title
              scrollable
              ref="picker"
              locale="ru"
              v-model="dateTo"
              @input="menu2 = false")
        v-flex(sm2 class="mx-2")
          v-btn(color="success" block @click="getIssues") Показать
      v-layout(justify-center class="pb-4")
        v-flex(xs11)
          DataTable(
            :headers="headers",
            :items="issues",
            :loading="loading",
            @show-issue-item="showIssueItem",)
    IssueItem(
      :show="show",
      :item="issueItem",
      @close-issue-item="closeIssueItem",
      @get-issue-list="this.getStatusList()")
    InfoPopup(:isVisibleModal="isShowModal", id="issue", name="Задачи",  @close-info-popup="closeModal")
</template
>s

<script>
import axios from 'axios'
import DataTable from '../../IssueStructure/components/DataTable/DataTable'
import IssueItem from '../IssueItem/IssueItem'
import InfoPopup from '../../DataBase/Common/InfoPopup'
export default {
  name: 'IssueList',
  components: { InfoPopup, IssueItem, DataTable },
  data: () => ({
    statusList: [],
    issues: [],
    issueItem: {},
    headers: [
      { text: '№', value: 'id', sortable: false },
      { text: 'ФИО ребенка', value: 'name' },
      { text: 'Назначено', value: 'dateFrom' },
      { text: 'Исполнить до', value: 'dateTo' },
      { text: 'Статус', value: 'status' },
      { text: 'Действие', value: 'action' }
    ],
    selectStatus: 'New',
    menu1: false,
    menu2: false,
    dateFrom: '',
    dateTo: '',
    loading: false,
    show: false,
    getIssueError: '',
    getStatusListError: '',
    isShowModal: false
  }),
  mounted() {
    this.getStatusList()
  },
  methods: {
    openModal() {
      this.isShowModal = true
    },
    closeModal() {
      this.isShowModal = false
    },
    showIssueItem(id) {
      this.issueItem = this.issues.find(item => item.id === id)
      this.show = true
    },
    closeIssueItem() {
      this.show = false
      this.issueItem = {}
    },
    getStatusList() {
      axios({
        method: 'GET',
        url: '/api/Issue/getStatusList'
      })
        .then(response => {
          this.statusList = response.data.result
        })
        .catch(error => {
          this.getStatusListError = error.response.data.message
        })
    },
    getIssues() {
      this.loading = true
      axios({
        method: 'GET',
        url: `/api/Issue/getChildList`,
        params: {
          status: this.selectStatus,
          startDate: this.dateFrom,
          endDate: this.dateTo
        }
      })
        .then(response => {
          this.issues = response.data.result
          this.loading = false
        })
        .catch(error => {
          this.getIssueError = error.response.data.message
          this.loading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.issue-list {
  .v-btn {
    height: 46px;
    transform: translateY(15px);
    border-radius: 4px;
  }
}
/*.issue-list {*/
/*  padding-top: 32px;*/
/*}*/
.v-card__title {
  position: relative;
  .back-btn {
    position: absolute;
    top: 0;
    left: 16px;
    width: 46px;
    height: 46px;
    border-radius: 25%;
  }
  .info-btn {
    position: absolute;
    top: 0;
    right: 16px;
    width: 46px;
    height: 46px;
    border-radius: 25%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/IssueStructure/IssueList/IsuueList.vue